import React from "react";
import { Link } from "react-router-dom";
import LegalLayout from "../components/LegalLayout";
import { legal, has, entityName } from "../data/legal";

const LAST_UPDATED = "25 June 2026";

export default function Disclaimer() {
  const entity = entityName();

  const sections = [
    {
      heading: "General information only",
      body: (
        <p>
          Nothing on this website is migration advice or an eligibility
          assessment. Everything here, including the visa pages, any guides, and
          our intake form, is general information only. It does not take account
          of your personal circumstances, and neither the site nor the intake
          form tells you which visa to apply for or whether you are eligible.
          Only a registered migration agent can advise you or assess your
          eligibility.
        </p>
      ),
    },
    {
      heading: "No client relationship through the site",
      body: (
        <p>
          Reading this site or completing our intake form does not make you a
          client of {entity} and does not create a professional relationship. We
          get your documentation application-ready and match you with a
          registered migration agent. Your relationship for the regulated advice
          and lodgement is with that agent, under their own agreement, and the
          agent provides the OMARA Consumer Guide.
        </p>
      ),
    },
    {
      heading: "No guarantee of outcome",
      body: (
        <p>
          Visa decisions are made solely by the Department of Home Affairs.
          Neither we nor the registered migration agent we match you with can
          guarantee any outcome, processing time, invitation, sponsorship, or
          visa grant. Any general information on this site is not a prediction or
          assurance of any result.
        </p>
      ),
    },
    {
      heading: "Accuracy and currency",
      body: (
        <p>
          Australian visa rules, fees, occupation lists, points settings, and
          processing times change frequently. While we work to keep this site
          current, we do not warrant that all information is complete or
          up to date at the time you read it. Always confirm current requirements
          for your situation, and check official Department of Home Affairs
          sources.
        </p>
      ),
    },
    {
      heading: "Fees and figures are indicative",
      body: (
        <p>
          Any figures mentioned on the site are indicative. Our support fee, the
          registered migration agent's professional fee, government Visa
          Application Charges, and third-party costs are separate. Government
          charges are set by the Department. Your actual costs are set out in the
          relevant agreements and the current government schedules.
        </p>
      ),
    },
    {
      heading: "External links",
      body: (
        <p>
          Links to third-party or government websites are provided for
          convenience. We are not responsible for the content or accuracy of
          external sites.
        </p>
      ),
    },
    {
      heading: "Who we are",
      body: (
        <p>
          {entity} is a migration support and coordination service. We are not a
          registered migration agent, we hold no MARN, and we are not a law
          firm. We do not provide migration advice or assess your
          eligibility. The registered migration agent we match you with does the
          regulated work.
        </p>
      ),
    },
    {
      heading: "Getting advice for your situation",
      body: (
        <p>
          For migration advice tailored to you, we match you with a registered
          migration agent who provides that advice. To get started, please{" "}
          <Link to="/book-consultation/">book a consultation</Link>
          {has(legal.email) ? (
            <>
              {" "}
              or email <a href={`mailto:${legal.email}`}>{legal.email}</a>
            </>
          ) : null}
          .
        </p>
      ),
    },
  ];

  return (
    <LegalLayout
      title="Disclaimer"
      path="/disclaimer/"
      description={`Important information about the general nature of the ${entity} website and its content.`}
      lastUpdated={LAST_UPDATED}
      intro="Please read this disclaimer about the information on our website."
      sections={sections}
    />
  );
}
